import type { AssessmentStep, Assessor } from "@/types/assessment";
import type { Competency } from "@/types/competency";

export const ACTION = {
  add_assessment_step: "add-assessment-step",
  add_assessment_steps: "add-assessment-steps",
  add_assessors: "add-assessors",
  add_assignment_competencies: "add-assignment-competencies",
  remove_assessment_step: "remove-assessment-step",
  remove_assessor: "remove-assessor",
  remove_assignment_competency: "remove-assignment-competency",
  toggle_edit: "toggle-edit",
  update_assessment_steps: "update-assessment-steps",
  update_assessors: "update-assessors",
  update_assignment_competencies: "update-assignment-competencies",
} as const;

export interface AssessmentGridState {
  assessment_steps: AssessmentStep[];
  assignment_competencies: Competency[];
  assessors: Assessor[];
  edit_mode: boolean;
}

// The "update" actions carry the single row the API echoed back; the "add" ones
// carry a whole list.
export type AssessmentGridAction =
  | { type: typeof ACTION.add_assessment_step; payload: AssessmentStep }
  | { type: typeof ACTION.add_assessment_steps; payload: AssessmentStep[] }
  | { type: typeof ACTION.add_assessors; payload: Assessor[] }
  | { type: typeof ACTION.add_assignment_competencies; payload: Competency[] }
  | { type: typeof ACTION.remove_assessment_step; payload: string }
  | {
      type: typeof ACTION.remove_assessor;
      payload: { email: string; assessment_step_id: string };
    }
  | { type: typeof ACTION.remove_assignment_competency; payload: string }
  | { type: typeof ACTION.toggle_edit }
  | { type: typeof ACTION.update_assessment_steps; payload: AssessmentStep }
  | { type: typeof ACTION.update_assessors; payload: Assessor }
  | { type: typeof ACTION.update_assignment_competencies; payload: Competency };
